import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px = 'M10.08 12.94 4.66 8l5.42-5Z';
const draw24px = 'M13.86,17,8.43,12l5.43-5Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const TriangleLeftIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'triangleLeft'),
) as IconWithRender;

TriangleLeftIcon.displayName = 'TriangleLeftIcon';
TriangleLeftIcon.propTypes = Icon.propTypes;
TriangleLeftIcon.renderIcon = (props) => <TriangleLeftIcon {...props} />;
export default TriangleLeftIcon;
